import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {Injectable} from '@angular/core';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable()
export class PdfServices {


  generarPdf(content:any){
    const docPdf = content;
    pdfMake.createPdf(docPdf).open();
  }
}
